import { useState } from "react";
import { ExternalLink } from "lucide-react";

const BFN_URL = "https://geodienste.bfn.de/schutzgebiete";

export default function NaturschutzMap() {
  const [loading, setLoading] = useState(true);

  return (
    <div className="space-y-4" data-testid="screen-naturschutz-map">
      <div className="card p-4 flex items-start gap-3">
        <div className="flex-1">
          <p className="text-sm text-[var(--color-app-text-secondary)] leading-relaxed">
            Offizielle Karte der Naturschutzgebiete des Bundesamts für Naturschutz (BfN).
            In Schutzgebieten gelten besondere Einschränkungen für den Drohnenbetrieb.
          </p>
        </div>
        <a
          href={BFN_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-secondary text-xs px-3 py-1.5 flex items-center gap-1.5 shrink-0"
          data-testid="link-bfn-extern"
        >
          <ExternalLink size={14} />
          In neuem Tab öffnen
        </a>
      </div>

      <div className="card relative overflow-hidden p-0" style={{ height: "70vh", minHeight: 480 }}>
        {loading ? (
          <div
            className="absolute inset-0 flex flex-col items-center justify-center bg-white/90 z-10"
            data-testid="naturschutz-loading"
          >
            <div className="h-8 w-8 rounded-full border-2 border-brand-200 border-t-brand-600 animate-spin" />
            <p className="mt-3 text-sm text-[var(--color-app-text-secondary)]">Karte wird geladen …</p>
          </div>
        ) : null}
        <iframe
          src={BFN_URL}
          title="Naturschutzgebiete (BfN)"
          className="w-full h-full border-0"
          onLoad={() => setLoading(false)}
          data-testid="naturschutz-iframe"
        />
      </div>
    </div>
  );
}
